interface AppRoute {
    AUTH: {
        LOGIN: string;
        PROFILE: string;
    };

    DASH_BOARD: {
        ROOT: string;
    };
    PROFILE: {
        ROOT: string;
        EDIT: string;
    };
    SYSTEM_ACCOUNT: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    COMPANY: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    COMPANY_ACCOUNT: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    CONTRACT: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    FRANCHISE: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    STORE: {
        ROOT: string;
        LIST: string;
        EDIT: string;
        ADD: string;
    };
    FORGOT_PASSWORD: {
        ROOT: string;
    };
    RESET_PASSWORD: {
        ROOT: string;
    };
    NOT_FOUND: string;
}

export const appRoutes: AppRoute = {
    AUTH: {
        LOGIN: 'login',
        PROFILE: 'profile',
    },
    SYSTEM_ACCOUNT: {
        ROOT: 'system-account',
        LIST: 'system-account/list',
        EDIT: 'system-account/edit', // /:id
        ADD: 'system-account/create',
    },
    COMPANY: {
        ROOT: 'company',
        LIST: 'company/list',
        EDIT: 'company/edit', //:id
        ADD: 'company/create',
    },
    COMPANY_ACCOUNT: {
        ROOT: 'company-account',
        LIST: 'company-account/list',
        EDIT: 'company-account/edit', // /:id
        ADD: 'company-account/create',
    },
    CONTRACT: {
        ROOT: 'contract',
        LIST: 'contract/list',
        EDIT: 'contract/edit', // /:id
        ADD: 'contract/create',
    },
    FRANCHISE: {
        ROOT: 'franchise',
        LIST: 'franchise/list',
        EDIT: 'franchise/edit', // /:id
        ADD: 'franchise/create',
    },
    STORE: {
        ROOT: 'store',
        LIST: 'store/list',
        EDIT: 'store/edit', // /:id
        ADD: 'store/create',
    },
    DASH_BOARD: {
        ROOT: '',
    },
    PROFILE: {
        ROOT: 'profile',
        EDIT: 'profile/edit',
    },
    FORGOT_PASSWORD: {
        ROOT: 'forgot-password',
    },
    RESET_PASSWORD: {
        ROOT: 'reset-password',
    },

    NOT_FOUND: '404',
};
